/**
 * Company details and legal copy.
 *
 * One source of truth: the payment page, the terms, the privacy notice and the
 * receipt all read from here, so an address change happens once.
 *
 * IMPORTANT - the text below is a working draft written to be accurate about
 * what this platform actually does. It is not legal advice and has not been
 * reviewed by a lawyer. A payment platform carries disclosure obligations that
 * vary by state and by the countries its merchants sell into; have counsel
 * review this before taking live payments.
 */

export const COMPANY = {
  legalName: 'Wyoming Cloud Solutions LLC',
  tradingName: 'WyoCSPay',
  address: {
    line1: '30 N Gould St Ste N',
    city: 'Sheridan',
    state: 'WY',
    postalCode: '82801',
    country: 'United States',
  },
  /**
   * The contact address on legal documents and receipts.
   *
   * Deliberately not the parent company's general address: this one appears in
   * the terms, on the payment page and as the Stripe support contact, so it has
   * to be an address that is answered for payment questions specifically.
   */
  email: 'pay@wyocs.org',
  /** Where a merchant or cardholder is directed for help. */
  supportEmail: 'help@wyocs.org',
  phone: '+1 (307) 888-5401',
  fax: '+1 (307) 448-1858',
  managingMember: 'Nikola Chakmakov',
  website: 'https://wyocs.org',
} as const;

export const addressLine = [
  COMPANY.address.line1,
  `${COMPANY.address.city}, ${COMPANY.address.state} ${COMPANY.address.postalCode}`,
  COMPANY.address.country,
].join(', ');

/** Bumped whenever the substance changes, so acceptance can be tied to a version. */
export const LEGAL_VERSION = '2026-07-28';

export interface LegalSection {
  heading: string;
  body: string[];
}

export interface LegalDocument {
  title: string;
  updated: string;
  intro: string;
  sections: LegalSection[];
}
